// Villa Data
export const villaData = {
  name: "Quba Nügədi Villa",
  tagline: "Təbiətin qoynunda rahat istirahət",
  location: "Quba şəhəri, Nügədi 1 kəndi, Azərbaycan",
  coordinates: { lat: 41.326725, lng: 48.573765 },
  phone: "+994999949944",
  whatsapp: "+994999949944",
  owner: "Samir",
  
  description: "Təbii mənzərə ilə əhatə olunmuş, yeni təmir edilmiş iki mərtəbəli villa. 3 otaq, 120 m² yaşayış sahəsi, 14 sot torpaq sahəsi. Ailələr və qruplar üçün ideal istirahət yeri.",
  
  pricing: {
    weekday: 150,
    weekend: 200,
    discount: "2 gecədən artıq qalma üçün endirim"
  },
  
  features: [
    { icon: "Bed", title: "3 Yataq Otağı", description: "Rahat və təmiz yataq otaqları" },
    { icon: "Utensils", title: "Geniş Mətbəx", description: "Tam təchiz olunmuş mətbəx" },
    { icon: "Waves", title: "Qızdırılan Hovuz", description: "6x3.5m qızdırılan hovuz" },
    { icon: "Trees", title: "Meyvə Bağı", description: "Geniş meyvə bağı ilə əhatə olunmuş" },
    { icon: "Wind", title: "Kondisioner", description: "Bütün otaqlarda kondisioner" },
    { icon: "Music", title: "Karaoke", description: "Karaoke sistemi" },
    { icon: "Film", title: "Açıq Havada Kino", description: "2.4x2.4m böyük ekran" },
    { icon: "Flame", title: "Manqal", description: "Samavar və manqal sahəsi" }
  ],
  
  amenities: [
    "3 yataq otağı",
    "Geniş mətbəx",
    "Söhbətgah / lounge",
    "6x3.5 qızdırılan hovuz",
    "Mətbəx ləvazimatları",
    "Samavar və manqal",
    "Geniş meyvə bağı",
    "Kondisioner",
    "Karaoke seti",
    "Açıq havada 2.4 x 2.4 böyük ekranlı kino",
    "Kabel TV",
    "Kombi sistemi",
    "Su, qaz, işıq",
    "Balkon",
    "Tam təmirli, əşyalı"
  ],
  
  photos: [
    "https://customer-assets.emergentagent.com/job_nugedi-retreat/artifacts/e2h7fgp4_Quba%20gunluk%20kiraye%20evler.jpeg",
    "https://customer-assets.emergentagent.com/job_nugedi-retreat/artifacts/pjcutepm_Quba%20gunluk%20kiraye%20evi.jpg",
    "https://customer-assets.emergentagent.com/job_nugedi-retreat/artifacts/8w0c1q19_Quba%20gunluk%20kiraye%20ev.jpeg",
    "https://customer-assets.emergentagent.com/job_nugedi-retreat/artifacts/lon6diq3_Quba%20gunluk%20ev.png",
    "https://customer-assets.emergentagent.com/job_nugedi-retreat/artifacts/c0rxfj2t_Quba%20evler.jpg"
  ],
  
  highlights: [
    "Təmiz və rahat",
    "Geniş həyət",
    "Təbiət mənzərəsi",
    "Uşaq və ailə üçün uyğun",
    "Xüsusi özəl villa"
  ]
};